/*
  Ruma Match - arayuz.
  Ekranlar (ana, harita, oyun, oduller, ayarlar), tahta cizimi, dokunma, animasyonlar, sunucu baglantisi.
  Kurallar ruma-match-motor.js'te, cizimler ruma-match-cizim.js'te, sayilar ruma-match-ayar.js'te.

  Sunucu (api/oyun.js) App Proxy uzerinden: GET durum, POST {islem: 'basla' | 'bitir' | 'odul'}.
  Oynamak icin Ruma hesabiyla giris zorunlu: giris yapmamis oyuncu sadece giris ekranini gorur.
*/
(function () {
  'use strict';

  var A = window.RumaMatchAyar, M = window.RumaMatchMotor, C = window.RumaMatchCizim;
  var kok = document.getElementById('ruma-match');
  if (!kok || !A || !M || !C) return;

  var cfg = {
    api: kok.getAttribute('data-api') || '/apps/koleksiyon/oyun',
    girisli: kok.getAttribute('data-girisli') === '1',
    giris: kok.getAttribute('data-giris') || '/account/login',
    magaza: kok.getAttribute('data-magaza') || '/'
  };
  var BOYUT = A.tahta.en;

  // ---------- yardimcilar ----------

  function kacis(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function sayi(n) { return Number(n || 0).toLocaleString(document.documentElement.lang === 'tr' ? 'tr-TR' : 'en-US'); }
  function bekleMs(ms) { return new Promise(function (c) { setTimeout(c, ms); }); }
  function T(ms) { return Math.round(ms * (tercih.hiz === 'hizli' ? 0.62 : 1)); }
  function bekle(ms) { return bekleMs(T(ms)); }
  var depo = {
    oku: function (k, v0) { try { var v = localStorage.getItem(k); return v ? JSON.parse(v) : v0; } catch (e) { return v0; } },
    yaz: function (k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) { /* depolama kapali olabilir */ } }
  };
  function titret(ms) { if (tercih.titresim && navigator.vibrate) { try { navigator.vibrate(ms); } catch (e) { /* desteklenmiyor */ } } }

  var tercih = depo.oku('rm-tercih', { hiz: 'normal', titresim: true });
  function tercihYaz() { depo.yaz('rm-tercih', tercih); kok.style.setProperty('--hiz', tercih.hiz === 'hizli' ? 0.62 : 1); }

  // ---------- sunucu ----------

  function istek(govde) {
    if (window.RumaMatchSahteSunucu) return window.RumaMatchSahteSunucu(govde);
    var opt = govde
      ? { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(govde), credentials: 'same-origin' }
      : { headers: { 'Accept': 'application/json' }, credentials: 'same-origin' };
    return fetch(cfg.api, opt).then(function (r) {
      if (!r.ok) throw new Error('http_' + r.status);
      return r.json();
    });
  }

  // Telefon uygulamadan cikip donunce ilk istek sik sik bos doner (baglanti uykuda kalmis olur).
  // Durum okuma ve level baslatma tekrarlanabilir islemler: kisa aralarla yeniden denenir.
  async function istekTekrarli(govde) {
    var beklemeler = [600, 1500, 3000];
    for (var i = 0; ; i++) {
      try {
        return await istek(govde);
      } catch (e) {
        var gecici = !/^http_4/.test(e && e.message);
        if (!gecici || i >= beklemeler.length) throw e;
        await bekleMs(beklemeler[i]);
      }
    }
  }

  var TR = document.documentElement.lang === 'tr';
  function T(tr, en) { return TR ? tr : en; }
  function odulBilgi(x) {
    var a = A.oduller.filter(function (o) { return o.id === x.id; })[0] || x;
    return { baslik: TR ? x.baslik : (a.baslik_en || x.baslik), aciklama: TR ? (x.aciklama || a.aciklama) : (a.aciklama_en || x.aciklama) };
  }
  var HATA = {
    level_kilitli: T('Bu level henüz açık değil.', 'This level is not open yet.'),
    oyun_bulunamadi: T('Bu deneme sunucuda bulunamadı, Coin verilmedi.', 'This attempt was not found on the server, no Coin was given.'),
    gecersiz_oyun: T('Oyun doğrulanamadı, Coin verilmedi.', 'The game could not be verified, no Coin was given.'),
    sure_doldu: T('Deneme çok uzun sürdü, Coin verilmedi.', 'The attempt took too long, no Coin was given.'),
    surum_degisti: T('Oyun güncellendi, bu deneme sayılmadı.', 'The game was updated, this attempt did not count.'),
    yetersiz_coin: T('Bu ödül için Coin\'in yetmiyor.', 'You don\'t have enough Coin for this reward.'),
    odul_yok: T('Bu ödül şu an alınamıyor.', 'This reward is not available right now.'),
    islem_suruyor: T('Önceki ödülün hazırlanıyor, birkaç saniye sonra tekrar dene.', 'Your previous reward is being prepared, try again in a few seconds.'),
    kod_uretilemedi: T('Kod oluşturulamadı, Coin\'in iade edildi. Biraz sonra tekrar dene.', 'The code could not be created, your Coin was refunded. Try again in a moment.')
  };
  function hataMetni(h) { return HATA[h] || T('Bir şeyler ters gitti, biraz sonra tekrar dene.', 'Something went wrong, please try again in a moment.'); }

  // ---------- hesap durumu ----------

  var durum = null;          // sunucudan gelen ozet (giris yapmis oyuncu)
  var baglanti = 'yukleniyor'; // 'tamam' | 'giris-yok' | 'hata'

  function ozet() { return durum; }
  function oynanacakLevel() { return Math.min(durum.acik, A.leveller.length); }

  // Giris durumunu sunucu soyler (App Proxy imzali musteri kimligi); sayfadaki isarete guvenilmez.
  function durumYukle() {
    return istekTekrarli(null).then(function (d) {
      if (d && d.coin) { durum = d; baglanti = 'tamam'; }
      else if (d && d.girisYapilmadi) { durum = null; baglanti = 'giris-yok'; }
      else if (d && d.yakinda) { durum = null; baglanti = 'yakinda'; }
      else baglanti = 'hata';
    }).catch(function () {
      // Sayfa musteriyi giris yapmis gosteriyorsa sorun baglantida; degilse giris yapilmamistir
      baglanti = cfg.girisli ? 'hata' : 'giris-yok';
    });
  }

  // ---------- gorsel atlas ----------
  // Butun taslar acilista tek bir resme cizilir; tahtada her tas o resmin bir parcasi olarak gosterilir.
  // Boylece 36 karmasik SVG her karede yeniden cizilmez, telefonda akici calisir.

  var ATLAS = { hazir: false, anahtar: {}, sutun: 8, satir: 1, url: null };

  function atlasListesi() {
    var l = [];
    A.meyveler.forEach(function (m) { l.push('m:' + m, 'y:' + m, 'd:' + m, 'b:' + m); });
    l.push('g', 'e:buz1', 'e:buz2', 'e:kutu1', 'e:kutu2', 'e:sarmasik');
    return l;
  }
  function anahtarIcerik(k) {
    if (k.indexOf('e:') === 0) return { ic: C.engelIc(k.slice(2)), olcek: 1 };
    if (k === 'g') return { ic: C.tasIc(null, 'g'), olcek: 1.2 };
    var p = k.split(':');
    return { ic: C.tasIc(p[1], p[0] === 'm' ? null : p[0]), olcek: 1.2 };
  }
  function atlasKur(hucrePx) {
    var dpr = Math.min(window.devicePixelRatio || 1, 3);
    var t = Math.max(64, Math.round(hucrePx * 1.2 * dpr));
    var liste = atlasListesi(), sutun = 8, satir = Math.ceil(liste.length / sutun), ic = '';
    liste.forEach(function (k, i) {
      var x = (i % sutun) * 240, y = Math.floor(i / sutun) * 240, c = anahtarIcerik(k), kay = (240 - 200 * c.olcek) / 2;
      ic += '<g transform="translate(' + (x + kay) + ' ' + (y + kay) + ') scale(' + c.olcek + ')">' + c.ic + '</g>';
      ATLAS.anahtar[k] = i;
    });
    var svg = ('<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="' + sutun * t + '" height="' + satir * t +
      '" viewBox="0 0 ' + sutun * 240 + ' ' + satir * 240 + '">' + C.spriteIc() + ic + '</svg>')
      .replace(/<use href="([^"]+)"/g, '<use width="200" height="200" href="$1" xlink:href="$1"');
    return new Promise(function (coz, red) {
      var img = new Image();
      img.onload = function () {
        try {
          var cv = document.createElement('canvas');
          cv.width = sutun * t; cv.height = satir * t;
          cv.getContext('2d').drawImage(img, 0, 0);
          cv.toBlob(function (b) {
            if (!b) return red(new Error('atlas'));
            if (ATLAS.url) URL.revokeObjectURL(ATLAS.url);
            ATLAS.url = URL.createObjectURL(b); ATLAS.sutun = sutun; ATLAS.satir = satir; ATLAS.px = hucrePx; ATLAS.hazir = true;
            coz();
          }, 'image/png');
        } catch (e) { red(e); }
      };
      img.onerror = function () { red(new Error('atlas')); };
      img.src = 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(svg);
    });
  }
  function gorselAyarla(el, k) {
    if (el._k === k) return;
    el._k = k;
    var i = el.firstChild;
    if (ATLAS.hazir && ATLAS.anahtar[k] != null) {
      var n = ATLAS.anahtar[k];
      i.innerHTML = '';
      i.style.backgroundImage = 'url(' + ATLAS.url + ')';
      i.style.backgroundSize = (ATLAS.sutun * 100) + '% ' + (ATLAS.satir * 100) + '%';
      i.style.backgroundPosition = ((n % ATLAS.sutun) / (ATLAS.sutun - 1) * 100) + '% ' + (Math.floor(n / ATLAS.sutun) / Math.max(1, ATLAS.satir - 1) * 100) + '%';
    } else {
      var c = anahtarIcerik(k);
      i.innerHTML = '<svg viewBox="-20 -20 240 240" overflow="visible"><g transform="translate(100 100) scale(' + c.olcek + ') translate(-100 -100)">' +
        c.ic.replace(/<use href=/g, '<use width="200" height="200" href=') + '</g></svg>';
    }
  }
  function tasAnahtari(p) { return p.o === 'g' ? 'g' : (p.o || 'm') + ':' + A.meyveler[p.m]; }

  // ---------- ekran altyapisi ----------

  kok.classList.add('rm-kok');
  kok.innerHTML = '<div class="rm-sahne" id="rm-sahne"></div>';
  var sahne = document.getElementById('rm-sahne');
  tercihYaz();
  C.yukle();

  function ekran(sinif, html) {
    ipucuDurdur();
    sahne.innerHTML = '<div class="rm-ekran ' + sinif + '">' + html + '</div>';
  }
  function pencere(html, kapatilir) {
    pencereKapat();
    var d = document.createElement('div');
    d.className = 'rm-perde';
    d.id = 'rm-perde';
    d.innerHTML = '<div class="rm-pencere" role="dialog" aria-modal="true">' + html + '</div>';
    if (kapatilir) d.addEventListener('click', function (e) { if (e.target === d) pencereKapat(); });
    sahne.appendChild(d);
    return d;
  }
  function pencereKapat() { var p = document.getElementById('rm-perde'); if (p) p.remove(); }
  function bildirim(metin) {
    var b = document.createElement('div');
    b.className = 'rm-bildirim';
    b.textContent = metin;
    sahne.appendChild(b);
    setTimeout(function () { b.remove(); }, 2700);
  }

  var IKON = {
    geri: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M15 5l-7 7 7 7"/></svg>',
    kilit: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round"><rect x="5" y="11" width="14" height="10" rx="2"/><path d="M8 11V8a4 4 0 0 1 8 0v3"/></svg>',
    harita: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="M9 4L3 6v14l6-2 6 2 6-2V4l-6 2-6-2z"/><path d="M9 4v14M15 6v14"/></svg>',
    ayar: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="3.2"/><path d="M12 2.5v3M12 18.5v3M21.5 12h-3M5.5 12h-3M18.7 5.3l-2.1 2.1M7.4 16.6l-2.1 2.1M18.7 18.7l-2.1-2.1M7.4 7.4L5.3 5.3"/></svg>',
    hediye: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="9" width="18" height="12" rx="2"/><path d="M3 13h18M12 9v12"/><path d="M12 9c-2-4-6-4-6-1.5S9 9 12 9zM12 9c2-4 6-4 6-1.5S15 9 12 9z"/></svg>'
  };

  function coinRozeti(kisa) {
    var o = ozet();
    if (!o || !o.coin) return '';
    return '<span class="rm-coin" title="Ruma Coin">' + C.ikon('rm-coin') + sayi(o.coin.bakiye) +
      (kisa ? '' : '<small>· ' + T('toplanan', 'collected') + ' ' + sayi(toplananCoin(o)) + '/' + sayi(tumCoin()) + '</small>') + '</span>';
  }
  function ustBar(baslik) {
    return '<div class="rm-ust-bar"><button class="rm-ikon-btn" data-eylem="ana" aria-label="' + T('Geri', 'Back') + '">' + IKON.geri + '</button>' +
      '<h2 class="rm-baslik rm-ust-baslik">' + kacis(baslik) + '</h2>' + (coinRozeti(true) || '<span style="width:46px"></span>') + '</div>';
  }

  // ---------- giris zorunlu ----------

  function afis() {
    return '<div class="rm-afis">' + C.ikon('rm-o-gunes', 'rm-afis-gunes') +
      '<h1 class="rm-logo"><span>r</span><span>u</span><span>m</span><span>a</span><b>match</b></h1>' +
      '<p class="rm-slogan">' + T('Ruma Koyu\'nu uyandır, yazın enerjisini topla', 'Wake up Ruma Village, collect the energy of summer') + '</p></div>';
  }
  function magazaDugmesi() {
    return '<div class="rm-ust-bar"><a class="rm-ikon-btn" href="' + kacis(cfg.magaza) + '" aria-label="' + T('Mağazaya dön', 'Back to the store') + '">' + IKON.geri + '</a><span></span></div>';
  }
  function baslangicEkrani() {
    if (baglanti === 'tamam' && durum) anaEkran();
    else if (baglanti === 'hata') baglantiHataEkrani();
    else if (baglanti === 'yakinda') yakindaEkrani();
    else girisEkrani();
  }
  // Giris yapmamis oyuncu oyunu goremez; sadece bu ekrani gorur
  function girisEkrani() {
    ekran('rm-ana',
      magazaDugmesi() + afis() +
      '<div class="rm-kasa"><h2 class="rm-baslik" style="font-size:25px;margin:0 0 8px">' + T('Oynamak için giriş yap', 'Log in to play') + '</h2>' +
        '<p class="rm-metin" style="margin:0">' + T('Ruma Match Ruma hesabınla oynanıyor. İlerlemen ve kazandığın Coin hesabına kaydedilir, başka bir cihazdan girdiğinde kaldığın yerden devam edersin.', 'Ruma Match is played with your Ruma account. Your progress and the Coin you earn are saved to your account, so you can pick up where you left off on any other device.') + '</p></div>' +
      '<div class="rm-devam"><button class="rm-btn genis" data-eylem="giris">' + T('Giriş yap', 'Log in') + '</button>' +
        '<p class="rm-alt-not">' + T('Hesabın yoksa giriş sayfasından birkaç saniyede oluşturabilirsin.', 'If you don\'t have an account, you can create one in a few seconds on the login page.') + '</p></div>');
  }
  // Gelistirme asamasi: sadece test ekibi oynar, digerleri bunu gorur
  function yakindaEkrani() {
    ekran('rm-ana',
      magazaDugmesi() + afis() +
      '<div class="rm-kasa"><h2 class="rm-baslik" style="font-size:25px;margin:0 0 8px">' + T('Çok yakında!', 'Coming very soon!') + '</h2>' +
        '<p class="rm-metin" style="margin:0">' + T('Ruma Match şu an son hazırlıklarını yapıyor. Oyun açıldığında Ruma hesabınla oynayıp Coin toplayabileceksin.', 'Ruma Match is getting its final touches. When the game opens, you will be able to play with your Ruma account and collect Coin.') + '</p></div>' +
      '<div class="rm-devam"><a class="rm-btn genis" href="' + kacis(cfg.magaza) + '">' + T('Mağazaya dön', 'Back to the store') + '</a></div>');
  }
  function baglantiHataEkrani() {
    ekran('rm-ana',
      magazaDugmesi() + afis() +
      '<div class="rm-kasa"><h2 class="rm-baslik" style="font-size:25px;margin:0 0 8px">' + T('Şu an bağlanamadık', 'We could not connect') + '</h2>' +
        '<p class="rm-metin" style="margin:0">' + T('İnternet bağlantını kontrol edip tekrar dene.', 'Check your internet connection and try again.') + '</p></div>' +
      '<div class="rm-devam"><button class="rm-btn genis" data-eylem="yeniden">' + T('Tekrar dene', 'Try again') + '</button></div>');
  }

  // ---------- ana ekran ----------

  function anaEkran() {
    if (!durum) { baslangicEkrani(); return; }
    var o = ozet(), n = oynanacakLevel();
    var kasa;
    {
      var c = o.coin, toplanan = toplananCoin(o), tum = tumCoin(), yuzde = Math.min(100, toplanan / tum * 100), ip;
      if (o.sonrakiOdul) ip = TR ? '<b>' + sayi(o.sonrakiOdul.kalan) + ' Coin</b> daha kazanırsan <b>' + sayi(o.sonrakiOdul.coin) + ' Coin</b> ödülüne ulaşacaksın.' : 'Earn <b>' + sayi(o.sonrakiOdul.kalan) + ' Coin</b> more to reach the <b>' + sayi(o.sonrakiOdul.coin) + ' Coin</b> reward.';
      else ip = T('En büyük ödülü alabilirsin. <b>Ödüller</b>\'e göz at.', 'You can claim the biggest reward. Check out <b>Rewards</b>.');
      if (toplanan >= tum) ip = T('Bütün level\'ların Coin\'ini topladın. Yeni level\'lar gelince yeni Coin açılacak.', 'You collected the Coin from all levels. New Coin unlocks when new levels arrive.');
      kasa = '<div class="rm-kasa">' +
        '<div class="rm-kasa-ust">' + C.ikon('rm-coin') + '<div class="rm-kasa-bakiye">' + sayi(c.bakiye) + '<small>Ruma Coin</small></div></div>' +
        '<div class="rm-cubuk" aria-hidden="true"><i style="width:' + yuzde + '%"></i></div>' +
        '<div class="rm-kasa-alt"><span>' + T('Level\'lardan toplanan: ', 'Collected from levels: ') + sayi(toplanan) + ' / ' + sayi(tum) + '</span></div>' +
        '<p class="rm-kasa-ipucu">' + ip + '</p></div>';
    }
    ekran('rm-ana',
      '<div class="rm-ust-bar"><a class="rm-ikon-btn" href="' + kacis(cfg.magaza) + '" aria-label="' + T('Mağazaya dön', 'Back to the store') + '">' + IKON.geri + '</a>' + coinRozeti() + '</div>' +
      '<div class="rm-afis">' + C.ikon('rm-o-gunes', 'rm-afis-gunes') +
        '<h1 class="rm-logo"><span>r</span><span>u</span><span>m</span><span>a</span><b>match</b></h1>' +
        '<p class="rm-slogan">' + T('Ruma Koyu\'nu uyandır, yazın enerjisini topla', 'Wake up Ruma Village, collect the energy of summer') + '</p></div>' +
      '<div class="rm-devam"><button class="rm-btn genis" data-eylem="level" data-n="' + n + '">' + T('Devam Et', 'Continue') + ' <small>· Level ' + n + '</small></button></div>' +
      kasa +
      '<div class="rm-menu">' +
        '<button class="rm-btn kagit" data-eylem="oduller">' + IKON.hediye + T('Ödüller', 'Rewards') + '</button>' +
        '<button class="rm-btn kagit" data-eylem="harita">' + IKON.harita + T('Level Haritası', 'Level Map') + '</button>' +
        '<button class="rm-btn kagit" data-eylem="ayarlar">' + IKON.ayar + T('Ayarlar', 'Settings') + '</button>' +
      '</div>');
  }

  // ---------- harita ----------

  function yildizMetni(y) {
    var s = '';
    for (var i = 1; i <= 3; i++) s += i <= y ? '<b>★</b>' : '<i>★</i>';
    return s;
  }
  function haritaEkrani() {
    var o = ozet(), d = '', suankiBolum = -1;
    for (var n = 1; n <= A.leveller.length; n++) {
      var b = A.bolumBilgi(n);
      if (b.i !== suankiBolum) {
        suankiBolum = b.i;
        d += '<div class="rm-harita-bolum"><span>' + T('Bölüm', 'Chapter') + ' ' + (b.i + 1) + ' · Level ' + b.bas + '–' + b.son + '</span><h3>' + kacis(b.ad) + '</h3></div>';
      }
      var y = o.yildiz[n] || 0, kilitli = n > o.acik, simdi = n === o.acik && !o.yildiz[n];
      d += '<div class="rm-durak' + (kilitli ? ' kilitli' : '') + (simdi ? ' simdi' : '') + '" data-n="' + n + '">' +
        '<button ' + (kilitli ? 'disabled aria-label="Level ' + n + T(' kilitli', ' locked') + '"' : 'data-eylem="level" data-n="' + n + '"') + '>' + (kilitli ? IKON.kilit : n) + '</button>' +
        '<span class="rm-yildizlar">' + (kilitli ? '' : yildizMetni(y)) + '</span></div>';
    }
    ekran('rm-harita-ekrani', ustBar(T('Level Haritası', 'Level Map')) + '<div class="rm-harita" id="rm-harita"><div class="rm-yol">' + d + '</div></div>');
    var h = document.querySelector('.rm-durak[data-n="' + oynanacakLevel() + '"]');
    if (h) h.scrollIntoView({ block: 'center' });
  }

  // ---------- hedef ikonlari ----------

  function hedefIkon(k) {
    if (A.meyveler.indexOf(k) >= 0) return C.meyve(k);
    if (k === 'roket') return C.ikon('rm-o-roket');
    if (k === 'bomba') return C.ikon('rm-o-bomba');
    if (k === 'gunes') return C.ikon('rm-o-gunes');
    if (k === 'buz') return C.engel('buz1');
    if (k === 'kutu') return C.engel('kutu1');
    if (k === 'sarmasik') return C.engel('sarmasik');
    return C.ikon('rm-coin');
  }
  function hedefListesi(hedefler, buyuk) {
    return hedefler.map(function (h) {
      return '<span class="rm-hedef' + (h.tamam ? ' tamam' : '') + '" data-hedef="' + h.anahtar + '">' + hedefIkon(h.anahtar) +
        '<span>' + (h.tamam ? '' : sayi(buyuk ? h.toplam : h.kalan)) + '</span></span>';
    }).join('');
  }

  // ---------- level girisi ----------

  function levelGiris(n) {
    var sev = A.leveller[n - 1], gecici = M.yeni(A, n, 1), b = A.bolumBilgi(n);
    pencere(
      '<p class="rm-bolum-adi">' + T('Bölüm', 'Chapter') + ' ' + (b.i + 1) + ' · ' + kacis(b.ad) + '</p>' +
      '<h2 class="rm-baslik">Level ' + n + '</h2>' +
      (n === b.bas ? '<p class="rm-bolum-giris">' + kacis(b.giris) + '</p>' : '') +
      '<div class="rm-buyuk-hedefler">' + hedefListesi(M.hedefDurumu(gecici), true) + '</div>' +
      '<p>' + (TR ? sev.hamle + ' hamlede hedefleri tamamla.' : 'Complete the goals in ' + sev.hamle + ' moves.') + '</p>' +
      '<p class="rm-yildiz-kurali"><span>' + C.ikon('rm-coin', 'rm-mini-coin') + levelCoinMetni(n) + '</span></p>' +
      '<p class="rm-yildiz-kurali"><span><b>★</b> ' + T('geç', 'pass') + '</span><span><b>★★</b> ' + sev.yildiz[0] + T(' hamle kala', ' moves left') + '</span><span><b>★★★</b> ' + sev.yildiz[1] + T(' hamle kala', ' moves left') + '</span></p>' +
      (sev.ipucu ? '<p style="color:var(--soluk)">' + kacis(TR ? sev.ipucu : (sev.ipucu_en || sev.ipucu)) + '</p>' : '') +
      '<div class="rm-dugmeler"><button class="rm-btn genis" data-eylem="oyna" data-n="' + n + '">' + T('Oyna', 'Play') + '</button>' +
      '<button class="rm-btn genis kagit" data-eylem="kapat">' + T('Vazgeç', 'Cancel') + '</button></div>', true);
  }

  // ---------- oyun ----------

  var oyun = null;
  var bekleyenBitis = null; // sunucuya giden level sonucu; bitmeden yeni level baslatilmaz

  async function levelBaslat(n) {
    pencereKapat();
    ekran('rm-yukleniyor-ekrani', '<div class="rm-yukleniyor">' + C.ikon('rm-o-gunes') + '</div>');
    var tohum, id;
    try {
      if (bekleyenBitis) { try { await bekleyenBitis; } catch (e) { /* sonucu bitis ekrani gosterdi */ } }
      var r = await istekTekrarli({ islem: 'basla', level: n });
      if (r && r.girisYapilmadi) { durum = null; baglanti = 'giris-yok'; baslangicEkrani(); return; }
      if (r && r.yakinda) { durum = null; baglanti = 'yakinda'; baslangicEkrani(); return; }
      if (!r.ok) throw new Error(r.hata || 'basla');
      tohum = r.oyun.tohum; id = r.oyun.id;
    } catch (e) {
      var bilinen = e && HATA[e.message];
      ekran('rm-yukleniyor-ekrani', '');
      pencere('<h2 class="rm-baslik">Level ' + n + T(' açılamadı', ' could not be opened') + '</h2><p>' + (bilinen || T('Bağlantı bir anlığına koptu. İlerlemen ve Coin\'in kayıtlı, tekrar dene.', 'The connection dropped for a moment. Your progress and Coin are saved, try again.')) + '</p>' +
        '<div class="rm-dugmeler">' + (bilinen ? '' : '<button class="rm-btn genis" data-eylem="oyna" data-n="' + n + '">' + T('Tekrar dene', 'Try again') + '</button>') +
        '<button class="rm-btn genis kagit" data-eylem="harita">' + T('Level haritası', 'Level map') + '</button>' +
        '<button class="rm-btn genis kagit" data-eylem="ana">' + T('Ana ekran', 'Home') + '</button></div>');
      return;
    }
    oyun = { st: M.yeni(A, n, tohum), level: n, id: id, hamleler: [], parcalar: {}, ortuler: {}, mesgul: false, secili: null, sonGoruntu: null };
    await oyunEkrani();
  }

  function hucreBoyutu() {
    var alan = document.getElementById('rm-tahta-alan');
    var w = sahne.clientWidth - 28, h = alan ? alan.clientHeight - 16 : w;
    return Math.max(34, Math.floor(Math.min(w, h, 560) / BOYUT));
  }

  async function oyunEkrani() {
    var st = oyun.st;
    ekran('rm-oyun',
      '<div class="rm-hud"><button class="rm-ikon-btn" data-eylem="cik" aria-label="' + T('Level\'dan çık', 'Exit level') + '">' + IKON.geri + '</button>' +
        '<div class="rm-hud-level">Level ' + oyun.level + '</div>' + (coinRozeti(true) || '<span style="width:46px"></span>') + '</div>' +
      '<div class="rm-panel"><div class="rm-hamle" id="rm-hamle"><b>' + st.hamle + '</b><span>' + T('hamle', 'moves') + '</span></div>' +
        '<div class="rm-hedef-kutu"><div class="rm-hedefler" id="rm-hedefler"></div>' +
        '<div class="rm-skor"><span id="rm-skor">0</span><div class="rm-skor-cubuk" id="rm-skor-cubuk" role="progressbar" aria-label="' + T('Level ilerlemesi', 'Level progress') + '" aria-valuemin="0" aria-valuemax="100"><i></i></div>' +
        '<span class="rm-hud-yildiz" id="rm-hud-yildiz" aria-label="' + T('Yıldız', 'Stars') + '"><b>★</b><b>★</b><b>★</b></span></div></div></div>' +
      '<div class="rm-tahta-alan" id="rm-tahta-alan"><div class="rm-tahta" id="rm-tahta">' +
        '<div class="rm-zemin" id="rm-zemin"></div><div class="rm-katman" id="rm-kutular"></div><div class="rm-katman" id="rm-parcalar"></div>' +
        '<div class="rm-katman" id="rm-ortuler"></div><div class="rm-efekt" id="rm-efekt"></div></div></div>' +
      '<p class="rm-alt-not" id="rm-alt-not">' + kacis((TR ? A.leveller[oyun.level - 1].ipucu : (A.leveller[oyun.level - 1].ipucu_en || A.leveller[oyun.level - 1].ipucu)) || '') + '</p>');

    var H = hucreBoyutu();
    oyun.H = H;
    kok.style.setProperty('--hucre', H + 'px');
    var zemin = '';
    for (var i = 0; i < BOYUT * BOYUT; i++) zemin += '<i class="' + ((Math.floor(i / BOYUT) + i % BOYUT) % 2 ? 'koyu' : '') + '"></i>';
    document.getElementById('rm-zemin').innerHTML = zemin;
    oyun.katman = { parca: document.getElementById('rm-parcalar'), kutu: document.getElementById('rm-kutular'), ortu: document.getElementById('rm-ortuler'), efekt: document.getElementById('rm-efekt') };

    if (!ATLAS.hazir || Math.abs(ATLAS.px - H) / H > 0.2) {
      try { await atlasKur(H); } catch (e) { ATLAS.hazir = false; }
    }
    goruntuUygula(M.goruntu(st), 0);
    hudGuncelle();
    tahtaDinle(document.getElementById('rm-tahta'));
    ipucuZamanla();
  }

  // --- tahtayi goruntuden kur ---

  function parcaYap(p, r, c) {
    var el = document.createElement('div');
    el.className = 'rm-parca';
    el.appendChild(document.createElement('i'));
    el._m = p.m >= 0 ? A.meyveler[p.m] : null;
    el._id = p.id;
    gorselAyarla(el, tasAnahtari(p));
    konumla(el, r, c, 0);
    oyun.katman.parca.appendChild(el);
    oyun.parcalar[p.id] = el;
    return el;
  }
  function konumla(el, r, c, sure) {
    el.style.transitionDuration = sure + 'ms';
    el.style.transform = 'translate(' + (c * oyun.H) + 'px,' + (r * oyun.H) + 'px)';
    el._r = r; el._c = c;
  }
  function ortuAyarla(anahtar, k, r, c, katman) {
    var el = oyun.ortuler[anahtar];
    if (!k) {
      if (el) {
        delete oyun.ortuler[anahtar];
        el.classList.add('kirik');
        setTimeout(function () { el.remove(); }, T(320));
      }
      return;
    }
    if (!el) {
      el = document.createElement('div');
      el.className = 'rm-ortu';
      el.appendChild(document.createElement('i'));
      el.style.transform = 'translate(' + (c * oyun.H) + 'px,' + (r * oyun.H) + 'px)';
      katman.appendChild(el);
      oyun.ortuler[anahtar] = el;
    } else if (el._k !== k) {
      el.classList.remove('sars'); void el.offsetWidth; el.classList.add('sars');
    }
    gorselAyarla(el, k);
  }
  function ortuleriUygula(g) {
    g.forEach(function (h) {
      var a = h.r + '_' + h.c;
      ortuAyarla('k' + a, h.kutu ? 'e:kutu' + h.kutu : null, h.r, h.c, oyun.katman.kutu);
      ortuAyarla('b' + a, h.buz ? 'e:buz' + h.buz : null, h.r, h.c, oyun.katman.ortu);
      ortuAyarla('s' + a, h.sar ? 'e:sarmasik' : null, h.r, h.c, oyun.katman.ortu);
    });
  }
  function goruntuUygula(g, sure) {
    var var_ = {};
    g.forEach(function (h) {
      if (!h.p) return;
      var el = oyun.parcalar[h.p.id] || parcaYap(h.p, h.r, h.c);
      gorselAyarla(el, tasAnahtari(h.p));
      if (el._r !== h.r || el._c !== h.c) konumla(el, h.r, h.c, sure);
      var_[h.p.id] = 1;
    });
    Object.keys(oyun.parcalar).forEach(function (id) {
      if (!var_[id]) { oyun.parcalar[id].remove(); delete oyun.parcalar[id]; }
    });
    ortuleriUygula(g);
    oyun.sonGoruntu = g;
  }
  function hucredekiParca(r, c) {
    var g = oyun.sonGoruntu;
    for (var i = 0; i < g.length; i++) if (g[i].r === r && g[i].c === c) return g[i];
    return null;
  }

  // --- HUD ---

  // Skoru eskisi+yeni arasinda kisa bir sure boyunca saydirir (anlik zipla(mayan) his),
  // ayni anda art arda gelirse (zincirli eslesme) bir onceki saymayi iptal edip kaldigi yerden devam eder.
  function skorGoster(hedef) {
    var el = document.getElementById('rm-skor');
    if (!el) return;
    var simdiki = oyun._skorGosterilen == null ? 0 : oyun._skorGosterilen;
    if (simdiki === hedef) { el.textContent = sayi(hedef); return; }
    if (oyun._skorKare) cancelAnimationFrame(oyun._skorKare);
    if (window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches) {
      oyun._skorGosterilen = hedef; el.textContent = sayi(hedef); return;
    }
    var baslangic = simdiki, t0 = performance.now(), sure = T(380), oyunRef = oyun;
    (function adim(t) {
      var k = Math.min(1, (t - t0) / sure), ease = 1 - Math.pow(1 - k, 3);
      var deger = Math.round(baslangic + (hedef - baslangic) * ease);
      oyunRef._skorGosterilen = deger;
      el.textContent = sayi(deger);
      if (k < 1 && oyun === oyunRef) oyunRef._skorKare = requestAnimationFrame(adim);
      else { el.classList.remove('vuruldu'); void el.offsetWidth; el.classList.add('vuruldu'); }
    })(t0);
  }

  function hudGuncelle(o) {
    var st = oyun.st, skor = o && o.skor != null ? o.skor : st.skor;
    var hedefler = o && o.hedefler ? o.hedefler : M.hedefDurumu(st);
    var hm = document.getElementById('rm-hamle');
    if (!hm) return;
    hm.firstChild.textContent = st.hamle;
    hm.classList.toggle('az', st.hamle <= 3 && !st.bitti);
    document.getElementById('rm-hedefler').innerHTML = hedefListesi(hedefler, false);
    skorGoster(skor);
    var tamam = hedefler.every(function (h) { return h.tamam; });
    // Cubuk iki sinyalin buyugunu gosterir: hedeflerin tamamlanma orani (dogru ama
    // hedef disi eslesmelerde ilerlemez) ve alinan puanin level'e gore olceklenmis orani
    // (her eslesmede hareket eder). Level gercekten bitince her zaman tam %100 ve yesil olur.
    var sev = A.leveller[oyun.level - 1];
    var referansSkor = sev.hamle * A.skor.eslesme3 * 1.5;
    var hedefOrani = hedefler.reduce(function (a, h) { return a + (h.toplam ? Math.min(1, h.yapilan / h.toplam) : 1); }, 0) / Math.max(1, hedefler.length);
    var skorOrani = Math.min(0.95, skor / referansSkor);
    var oran = tamam ? 1 : Math.max(hedefOrani, skorOrani);
    var cubuk = document.getElementById('rm-skor-cubuk');
    cubuk.firstChild.style.width = Math.round(oran * 100) + '%';
    cubuk.setAttribute('aria-valuenow', Math.round(oran * 100));
    cubuk.classList.toggle('tamam', tamam);
    // Yildizlar kalan hamleye gore: su an bitirsen alacagin yildizlar yanar, hamle esigin altina inince o yildiz soner
    var es = st.yildizEsik, yanan = M.yildizHesap(st.hamle, es);
    var kutuY = document.getElementById('rm-hud-yildiz'), yildizlar = kutuY.children;
    for (var i = 0; i < 3; i++) {
      var dolu = i < yanan, onceki = yildizlar[i].classList.contains('dolu');
      yildizlar[i].classList.toggle('dolu', dolu);
      if (onceki && !dolu) { yildizlar[i].classList.remove('sondu'); void yildizlar[i].offsetWidth; yildizlar[i].classList.add('sondu'); }
    }
    kutuY.setAttribute('aria-label', yanan + T(' yıldız', ' stars'));
    kutuY.title = TR ? (yanan >= 3 ? '3 yıldız için en az ' + es[1] + ' hamle kala bitir' : yanan === 2 ? '2 yıldız için en az ' + es[0] + ' hamle kala bitir' : 'Level\'ı geçmek 1 yıldız') : (yanan >= 3 ? 'Finish with at least ' + es[1] + ' moves left for 3 stars' : yanan === 2 ? 'Finish with at least ' + es[0] + ' moves left for 2 stars' : 'Passing the level gives 1 star');
  }

  // --- dokunma ---

  function tahtaDinle(el) {
    var bas = null;
    function hucre(e) {
      var r = el.getBoundingClientRect();
      var x = e.clientX - r.left - el.clientLeft, y = e.clientY - r.top - el.clientTop;
      var c = Math.floor(x / oyun.H), rr = Math.floor(y / oyun.H);
      return (c < 0 || rr < 0 || c >= BOYUT || rr >= BOYUT) ? null : [rr, c];
    }
    el.addEventListener('pointerdown', function (e) {
      if (!oyun || oyun.mesgul || oyun.st.bitti) return;
      var h = hucre(e);
      if (!h) return;
      bas = { x: e.clientX, y: e.clientY, h: h, suruklendi: false };
      try { el.setPointerCapture(e.pointerId); } catch (x) { /* eski tarayici */ }
      ipucuDurdur();
    });
    el.addEventListener('pointermove', function (e) {
      if (!bas || bas.suruklendi) return;
      var dx = e.clientX - bas.x, dy = e.clientY - bas.y;
      if (Math.max(Math.abs(dx), Math.abs(dy)) < oyun.H * 0.3) return;
      bas.suruklendi = true;
      var b = Math.abs(dx) > Math.abs(dy) ? [bas.h[0], bas.h[1] + (dx > 0 ? 1 : -1)] : [bas.h[0] + (dy > 0 ? 1 : -1), bas.h[1]];
      secimTemizle();
      dene(bas.h, b);
    });
    el.addEventListener('pointerup', function () {
      if (bas && !bas.suruklendi) dokun(bas.h);
      bas = null;
    });
    el.addEventListener('pointercancel', function () { bas = null; });
  }
  function oynarMi(h) { return h && h.p && !h.kutu && !h.sar; }
  function secimTemizle() {
    if (oyun.secili) {
      var s = hucredekiParca(oyun.secili[0], oyun.secili[1]);
      if (s && s.p && oyun.parcalar[s.p.id]) oyun.parcalar[s.p.id].classList.remove('secili');
    }
    oyun.secili = null;
  }
  function dokun(h) {
    if (oyun.mesgul) return;
    var s = oyun.secili;
    if (s && Math.abs(s[0] - h[0]) + Math.abs(s[1] - h[1]) === 1) { secimTemizle(); dene(s, h); return; }
    secimTemizle();
    var hc = hucredekiParca(h[0], h[1]);
    // Secili power-up'a ikinci kez dokunmak onu yerinde patlatir
    if (s && s[0] === h[0] && s[1] === h[1]) { if (oynarMi(hc) && hc.p.o) dene(h, h); return; }
    if (!oynarMi(hc)) { if (hc && hc.p && oyun.parcalar[hc.p.id]) salla(oyun.parcalar[hc.p.id]); return; }
    oyun.secili = h;
    oyun.parcalar[hc.p.id].classList.add('secili');
  }
  function salla(el) { el.classList.remove('titre'); void el.offsetWidth; el.classList.add('titre'); }

  async function dene(a, b) {
    if (!oyun || oyun.mesgul || oyun.st.bitti) return;
    if (b[0] < 0 || b[1] < 0 || b[0] >= BOYUT || b[1] >= BOYUT) return;
    oyun.mesgul = true;
    ipucuDurdur();
    var s = M.hamle(oyun.st, a, b);
    if (s.ok) oyun.hamleler.push([a[0], a[1], b[0], b[1]]);
    else if (s.neden === 'oynamaz') {
      [a, b].forEach(function (x) { var h = hucredekiParca(x[0], x[1]); if (h && h.p && oyun.parcalar[h.p.id]) salla(oyun.parcalar[h.p.id]); });
    }
    await olaylariOynat(s.olaylar);
    hudGuncelle();
    oyun.mesgul = false;
    if (oyun.st.bitti) bitisGoster();
    else ipucuZamanla();
  }

  // --- animasyonlar ---

  async function olaylariOynat(olaylar) {
    var zincir = 0;
    for (var i = 0; i < olaylar.length; i++) {
      var o = olaylar[i];
      if (o.tur === 'geri') await geriAnim(o.a, o.b);
      else if (o.tur === 'takas') { goruntuUygula(o.tahta, T(170)); await bekle(185); }
      else if (o.tur === 'patla') { zincir++; await patlaAnim(o, zincir); }
      else if (o.tur === 'dus') await dusAnim(o);
      else if (o.tur === 'karistir') await karistirAnim(o);
    }
  }

  async function geriAnim(a, b) {
    var ha = hucredekiParca(a[0], a[1]), hb = hucredekiParca(b[0], b[1]);
    var ea = ha && ha.p && oyun.parcalar[ha.p.id], eb = hb && hb.p && oyun.parcalar[hb.p.id];
    if (!ea || !eb) return;
    konumla(ea, b[0], b[1], T(150)); konumla(eb, a[0], a[1], T(150));
    await bekle(160);
    konumla(ea, a[0], a[1], T(150)); konumla(eb, b[0], b[1], T(150));
    await bekle(160);
    salla(ea);
    titret(8);
  }

  function efekt(sinif, stil, sure) {
    var d = document.createElement('div');
    d.className = sinif;
    d.setAttribute('style', stil);
    oyun.katman.efekt.appendChild(d);
    setTimeout(function () { d.remove(); }, T(sure || 700));
    return d;
  }
  function ozelEfekt(a) {
    var H = oyun.H, cx = (a.c + 0.5) * H, cy = (a.r + 0.5) * H;
    if (a.o === 'y') efekt('rm-isin', 'left:0;top:' + (a.r * H + H * 0.28) + 'px;width:' + (BOYUT * H) + 'px;height:' + (H * 0.44) + 'px');
    else if (a.o === 'd') efekt('rm-isin dikey', 'top:0;left:' + (a.c * H + H * 0.28) + 'px;height:' + (BOYUT * H) + 'px;width:' + (H * 0.44) + 'px');
    else if (a.o === 'b') {
      var R = (A.guc.bombaYaricap * 2 + 1.4) * H;
      efekt('rm-halka', 'left:' + (cx - R / 2) + 'px;top:' + (cy - R / 2) + 'px;width:' + R + 'px;height:' + R + 'px');
    } else if (a.o === 'g') efekt('rm-parilti', '--x:' + cx + 'px;--y:' + cy + 'px', 800);
  }
  function suSac(r, c, renk) {
    var H = oyun.H, cx = (c + 0.5) * H, cy = (r + 0.5) * H;
    for (var i = 0; i < 7; i++) {
      var a = Math.random() * Math.PI * 2, u = H * (0.55 + Math.random() * 0.7);
      efekt('rm-damla', 'left:' + cx + 'px;top:' + cy + 'px;background:' + renk + ';--x:' + (Math.cos(a) * u) + 'px;--y:' + (Math.sin(a) * u - H * 0.2) +
        'px;--a:' + Math.round(Math.random() * 360) + 'deg;width:' + (H * 0.16) + 'px;height:' + (H * 0.16) + 'px', 600);
    }
  }
  function afisYazi(metin) {
    var d = document.createElement('div');
    d.className = 'rm-afis-yazi';
    d.textContent = metin;
    document.getElementById('rm-tahta').appendChild(d);
    setTimeout(function () { d.remove(); }, 1100);
  }

  async function patlaAnim(o, zincir) {
    var H = oyun.H;
    o.aktive.forEach(ozelEfekt);
    o.silinen.forEach(function (id) {
      var el = oyun.parcalar[id];
      if (!el) return;
      delete oyun.parcalar[id];
      el.classList.remove('secili', 'ipucu');
      el.classList.add('pat');
      suSac(el._r, el._c, el._m ? C.sular[el._m] : '#FFC233');
      setTimeout(function () { el.remove(); }, T(270));
    });
    if (o.vurulan.length && o.puan) {
      var sx = 0, sy = 0;
      o.vurulan.forEach(function (v) { sx += v[1]; sy += v[0]; });
      efekt('rm-puan', 'left:' + ((sx / o.vurulan.length + 0.5) * H) + 'px;top:' + ((sy / o.vurulan.length + 0.5) * H) + 'px', 900)
        .innerHTML = '+' + sayi(o.puan) + (o.carpan > 1 ? '<em>x' + o.carpan + '</em>' : '');
    }
    titret(o.aktive.length ? 28 : 10);
    if (zincir === 3) afisYazi(T('Süper!', 'Super!'));
    else if (zincir === 5) afisYazi(T('Harika!', 'Great!'));
    else if (zincir === 7) afisYazi(T('Muhteşem!', 'Amazing!'));
    hudGuncelle(o);
    await bekle(o.aktive.length ? 230 : 170);
    goruntuUygula(o.tahta, 0);
    o.olusan.forEach(function (id) {
      var el = oyun.parcalar[id];
      if (!el) return;
      el.classList.add('dogus');
      setTimeout(function () { el.classList.remove('dogus'); }, T(380));
    });
    await bekle(o.olusan.length ? 230 : 60);
  }

  async function dusAnim(o) {
    var enUzun = 0;
    o.tahta.forEach(function (h) {
      if (!h.p) return;
      var el = oyun.parcalar[h.p.id], yeni = !el;
      if (yeni) { el = parcaYap(h.p, o.dogan[h.p.id] != null ? o.dogan[h.p.id] : h.r - 1, h.c); void el.offsetWidth; }
      var mesafe = h.r - el._r;
      if (mesafe <= 0 && !yeni) return;
      var sure = T(Math.min(480, 130 + 62 * Math.max(1, mesafe)));
      konumla(el, h.r, h.c, sure);
      enUzun = Math.max(enUzun, sure);
      setTimeout(function () {
        el.classList.remove('otur'); void el.offsetWidth; el.classList.add('otur');
        setTimeout(function () { el.classList.remove('otur'); }, T(240));
      }, sure);
    });
    ortuleriUygula(o.tahta);
    oyun.sonGoruntu = o.tahta;
    await bekleMs(enUzun + T(50));
  }

  async function karistirAnim(o) {
    Object.keys(oyun.parcalar).forEach(function (id) { oyun.parcalar[id].classList.add('karis'); });
    await bekle(240);
    goruntuUygula(o.tahta, 0);
    Object.keys(oyun.parcalar).forEach(function (id) { oyun.parcalar[id].classList.remove('karis'); });
    await bekle(260);
    bildirim(T('Hamle kalmadı, meyveler karıştırıldı', 'No moves left, the fruits were shuffled'));
  }

  // --- ipucu ---

  var ipucuSayac = null;
  function ipucuZamanla() {
    ipucuDurdur();
    ipucuSayac = setTimeout(function () {
      if (!oyun || oyun.mesgul || oyun.st.bitti) return;
      var h = M.olasiHamle(oyun.st);
      if (!h) return;
      h.forEach(function (x) {
        var p = hucredekiParca(x[0], x[1]);
        if (p && p.p && oyun.parcalar[p.p.id]) oyun.parcalar[p.p.id].classList.add('ipucu');
      });
    }, 6000);
  }
  function ipucuDurdur() {
    clearTimeout(ipucuSayac);
    if (oyun && oyun.parcalar) Object.keys(oyun.parcalar).forEach(function (id) { oyun.parcalar[id].classList.remove('ipucu'); });
  }

  // --- bitis ---

  // Sunucu ayni denemeyi ikinci kez saymaz (ayni cevabi dondurur), bu yuzden baglanti kopunca tekrar gondermek guvenli
  async function bitirGonder(govde) {
    var beklemeler = [1500, 3500, 7000];
    for (var i = 0; ; i++) {
      try {
        var r = await istek(govde);
        if (r && r.ok === false && r.hata === 'islem_suruyor' && i < beklemeler.length) { await bekle(beklemeler[i]); continue; }
        return r;
      } catch (e) {
        if (i >= beklemeler.length) throw e;
        await bekle(beklemeler[i]);
      }
    }
  }

  // Bir sonraki yildiz icin ne gerektigi (bitis ekraninda tek satir)
  function yildizNotu(st, y) {
    var es = st.yildizEsik;
    if (y >= 3) return T('En iyi sonuç!', 'Best result!');
    return TR ? (y + 1) + '. yıldız için en az <b>' + es[y - 1] + ' hamle</b> kala bitir.' : 'Finish with at least <b>' + es[y - 1] + ' moves</b> left for star ' + (y + 1) + '.';
  }
  function dokumMetni(dk) {
    if (!dk) return '';
    var p = [];
    if (dk.gecis) p.push(T('Geçiş ', 'Pass ') + dk.gecis);
    if (dk.yildiz) p.push(TR ? dk.yeniYildiz + (dk.gecis ? '' : ' yeni') + ' yıldız +' + dk.yildiz : dk.yeniYildiz + (dk.gecis ? '' : ' new') + (dk.yeniYildiz === 1 ? ' star' : ' stars') + ' +' + dk.yildiz);
    return p.join(' · ');
  }
  function tumCoin() {
    var t = 0;
    for (var l = 1; l <= A.leveller.length; l++) t += A.gecisCoini(l) + 3 * A.ekonomi.yildizBasina;
    return t;
  }
  // Oyuncunun level'lardan su ana kadar topladigi Coin (her level bir kez oder)
  function toplananCoin(o) {
    var t = 0, od = (o && o.odenen) || {};
    for (var l = 1; l <= A.leveller.length; l++) if (od[l] != null) t += A.gecisCoini(l) + od[l] * A.ekonomi.yildizBasina;
    return t;
  }
  // Level girisinde: bu level'dan hala alinabilecek Coin
  function levelCoinMetni(n) {
    var o = ozet(), odenen = o && o.odenen ? o.odenen[n] : null, yb = A.ekonomi.yildizBasina;
    if (odenen == null) return TR ? 'Geçince ' + A.gecisCoini(n) + ' Coin, her yıldız +' + yb : 'Passing gives ' + A.gecisCoini(n) + ' Coin, each star +' + yb;
    if (odenen >= 3) return T('Bu level\'ın bütün Coin\'ini aldın', 'You collected all the Coin from this level');
    return TR ? 'Kalan: her yeni yıldız +' + yb + ' Coin (en fazla ' + (3 - odenen) * yb + ')' : 'Remaining: each new star +' + yb + ' Coin (up to ' + (3 - odenen) * yb + ')';
  }

  async function bitisGoster() {
    var oyunRef = oyun, st = oyun.st, kazandi = st.kazandi, y = M.yildiz(st), n = oyun.level;
    var sonucSozu = bitirGonder({ islem: 'bitir', id: oyun.id, hamleler: oyun.hamleler });
    bekleyenBitis = sonucSozu;
    sonucSozu.then(function () { if (bekleyenBitis === sonucSozu) bekleyenBitis = null; }, function () { if (bekleyenBitis === sonucSozu) bekleyenBitis = null; });
    if (kazandi) { afisYazi(st.hamle > 0 ? T('Level geçildi!', 'Level passed!') : T('Tam zamanında!', 'Just in time!')); titret(40); await bekle(1000); }
    else await bekle(400);

    // Bu, kazandi ve bu level daha once hic yildizi olmayan bir bolum-sonu level'iysa: kutlama ekranina
    // gececegiz. O aninin onune gecilmesin diye asagida gezinme dugmeleri hic gosterilmez (bekle, sonra otomatik gecer).
    var bit = A.bolumBilgi(n);
    var bolumSonuAcilisi = kazandi && n === bit.son && !(durum && durum.yildiz && durum.yildiz[String(n)]);

    var yildizHtml = '<div class="rm-uc-yildiz" aria-label="' + y + T(' yıldız', ' stars') + '"><span>★</span><span>★</span><span>★</span></div>';
    var p = pencere(
      '<h2 class="rm-baslik">' + (kazandi ? (TR ? 'Level ' + n + ' geçildi' : 'Level ' + n + ' passed') : T('Hamleler bitti', 'Out of moves')) + '</h2>' +
      (kazandi ? yildizHtml + '<p class="rm-kazanc-not">' + yildizNotu(st, y) + '</p>' : '<p>' + T('Hedeflere çok az kaldı. Bir kez daha dene!', 'So close to the goals. Try once more!') + '</p>') +
      '<p>' + T('Skor: ', 'Score: ') + '<b>' + sayi(st.skor) + '</b></p>' +
      '<div id="rm-kazanc"><p class="rm-kazanc-not">' + T('Coin hesaplanıyor…', 'Calculating Coin…') + '</p></div>' +
      (bolumSonuAcilisi ? '' :
      '<div class="rm-dugmeler">' +
        (kazandi && n < A.leveller.length ? '<button class="rm-btn genis" data-eylem="level" data-n="' + (n + 1) + '">' + T('Sonraki level', 'Next level') + '</button>' : '') +
        (!kazandi ? '<button class="rm-btn genis" data-eylem="level" data-n="' + n + '">' + T('Tekrar dene', 'Try again') + '</button>' : '') +
        '<button class="rm-btn genis kagit" data-eylem="harita">' + T('Level haritası', 'Level map') + '</button>' +
        '<button class="rm-btn genis kagit" data-eylem="ana">' + T('Ana ekran', 'Home') + '</button>' +
      '</div>'));
    if (kazandi) {
      var sp = p.querySelectorAll('.rm-uc-yildiz span');
      for (var i = 0; i < y; i++) { await bekle(260); sp[i].classList.add('yandi'); titret(12); }
    }

    // Butonlar bolumSonuAcilisi icin yukarida gizlendi. Kutlamaya gidemedigimiz her cikista
    // (hata, oturum kopmasi, beklenmedik durum) bu satiri kutuya ekleyip oyuncuyu sikismis birakmayiz.
    function acilAcikKalmasin() { return bolumSonuAcilisi ? '<div class="rm-dugmeler" style="margin-top:14px">' +
      (n < A.leveller.length ? '<button class="rm-btn genis" data-eylem="level" data-n="' + (n + 1) + '">' + T('Sonraki level', 'Next level') + '</button>' : '') +
      '<button class="rm-btn genis kagit" data-eylem="harita">' + T('Level haritası', 'Level map') + '</button>' +
      '<button class="rm-btn genis kagit" data-eylem="ana">' + T('Ana ekran', 'Home') + '</button></div>' : ''; }

    var kutu = document.getElementById('rm-kazanc');
    try {
      var r = await sonucSozu;
      if (r.durum) durum = r.durum;
      if (!kutu) return;
      if (r.girisYapilmadi) {
        kutu.innerHTML = '<p class="rm-kazanc-not">' + T('Oturumun kapanmış, bu oyunun Coin\'i kaydedilemedi. Tekrar giriş yapıp devam et.', 'Your session has ended, the Coin from this game could not be saved. Log in again to continue.') + '</p>' +
          '<button class="rm-btn kucuk petrol" data-eylem="giris" style="margin-top:8px">' + T('Giriş yap', 'Log in') + '</button>' + acilAcikKalmasin();
        return;
      }
      if (!r.ok) { kutu.innerHTML = '<p class="rm-kazanc-not">' + kacis(hataMetni(r.hata)) + '</p>' + acilAcikKalmasin(); return; }
      var not = '';
      if (r.cokHizli) not = T('Çok hızlı bitti, bu deneme Coin vermedi.', 'It finished too fast, this attempt gave no Coin.');
      else if (r.limitNotu === 'aylik_limit') not = T('Bu ayki Coin sınırına ulaştın. Yeni hakkın gelecek ay açılıyor.', 'You reached this month\'s Coin limit. Your new allowance opens next month.');
      if (!r.cokHizli && !r.hakEdilen) {
        kutu.innerHTML = '<p class="rm-kazanc-not">' + (kazandi
          ? T('Bu level\'ın Coin\'ini daha önce aldın. Yeni Coin için sonraki level\'lara geç ya da eksik yıldızlarını tamamla.', 'You already collected this level\'s Coin. Move on to the next levels or complete your missing stars for new Coin.')
          : T('Coin level geçince gelir. Bir kez daha dene!', 'Coin comes when you pass the level. Try once more!')) + '</p>' + acilAcikKalmasin();
        return;
      }
      var dokum = r.coin === r.hakEdilen ? dokumMetni(r.dokum) : '';
      kutu.innerHTML = '<div class="rm-kazanc">' + C.ikon('rm-coin') + '+' + sayi(r.coin) + ' Ruma Coin</div>' +
        (dokum ? '<p class="rm-kazanc-not" style="margin-top:4px">' + kacis(dokum) + '</p>' : '') +
        (not ? '<p class="rm-kazanc-not" style="margin-top:6px">' + kacis(not) + '</p>' : '');
      if (bolumSonuAcilisi && r.sonuc && r.sonuc.ilkKez) {
        await bekle(1400);
        if (oyun === oyunRef) bolumKutlamaGoster(bit.i);
      } else {
        kutu.innerHTML += acilAcikKalmasin();
      }
    } catch (e) {
      if (kutu) kutu.innerHTML = '<p class="rm-kazanc-not">' + T('Bağlantı koptu, Coin hesaplanamadı.', 'The connection dropped, Coin could not be calculated.') + '</p>' + acilAcikKalmasin();
    }
  }

  // Bir bolumun son level'i ilk kez gecilince gosterilen kutlama ekrani (guneş bolume gore daha canli/parlak)
  async function bolumKutlamaGoster(i) {
    var b = A.bolumBilgi(i === 0 ? 1 : A.bolumler[i - 1].son + 1);
    ekran('rm-kutlama-ekran',
      '<div class="rm-kutlama">' +
        '<div class="rm-kutlama-gunes" style="--evre:' + i + '">' + C.ikon('rm-o-gunes') + '</div>' +
        '<p class="rm-kutlama-ust">' + (TR ? 'Bölüm ' + (i + 1) + ' tamamlandı' : 'Chapter ' + (i + 1) + ' complete') + '</p>' +
        '<h2 class="rm-baslik">' + kacis(b.ad) + '</h2>' +
        '<p class="rm-kutlama-not">' + kacis(b.kutlama) + '</p>' +
        '<button class="rm-btn genis" data-eylem="harita">' + T('Devam Et', 'Continue') + '</button>' +
      '</div>');
    titret(30);
  }

  function cikisSor() {
    pencere('<h2 class="rm-baslik">' + T('Level\'dan çık?', 'Exit the level?') + '</h2><p>' + T('Bu deneme sayılmaz ve Coin kazandırmaz.', 'This attempt will not count and will not earn Coin.') + '</p>' +
      '<div class="rm-dugmeler"><button class="rm-btn genis" data-eylem="kapat">' + T('Oynamaya devam et', 'Keep playing') + '</button>' +
      '<button class="rm-btn genis kagit" data-eylem="cik-onay">' + T('Çık', 'Exit') + '</button></div>', true);
  }

  // ---------- oduller ----------

  function odullerEkrani() {
    var o = ozet(), liste = '';
    liste += '<div class="rm-kasa"><div class="rm-kasa-ust">' + C.ikon('rm-coin') + '<div class="rm-kasa-bakiye">' + sayi(o.coin.bakiye) + '<small>Ruma Coin</small></div></div>' +
      '<div class="rm-kasa-alt" style="margin-top:8px"><span>' + T('Level\'lardan toplanan: ', 'Collected from levels: ') + sayi(toplananCoin(o)) + ' / ' + sayi(tumCoin()) + '</span></div></div>';
    liste += odulKartlari(o);
    var kodlar = (o.oduller || []).filter(function (x) { return x.durum === 'hazir' && x.kod; });
    if (kodlar.length) {
      liste += '<h3 class="rm-bolum-baslik">' + T('Kodların', 'Your codes') + '</h3>';
      kodlar.forEach(function (x) {
        var bitis = x.bitis ? new Date(x.bitis) : null;
        liste += '<div class="rm-kod"><strong>' + kacis(odulBilgi(x).baslik) + '</strong>' +
          '<button data-eylem="kopyala" data-kod="' + kacis(x.kod) + '" aria-label="' + T('Kodu kopyala', 'Copy code') + '">' + kacis(x.kod) + '</button>' +
          '<small>' + (x.kullanildi ? T('Kullanıldı', 'Used') : TR ? 'Kopyalamak için koda dokun' + (bitis ? ' · ' + bitis.toLocaleDateString('tr-TR') + ' tarihine kadar geçerli' : '') : 'Tap the code to copy' + (bitis ? ' · valid until ' + bitis.toLocaleDateString('en-GB') : '')) + '</small></div>';
      });
    }
    liste += '<p class="rm-kasa-alt" style="line-height:1.5">' + T('Kodlar hesabına özel ve tek kullanımlıktır, başka bir Ruma oyun ödülüyle aynı siparişte kullanılamaz.', 'Codes are specific to your account and single-use, and cannot be used with another Ruma game reward in the same order.') + '</p>';
    ekran('rm-oduller', ustBar(T('Ödüller', 'Rewards')) + '<div class="rm-liste">' + liste + '</div>');
  }
  function odulKartlari(o) {
    return A.oduller.map(function (x) {
      var dugme;
      if (!x.aktif) dugme = '<button class="rm-btn kucuk kagit" disabled>' + T('Yakında', 'Soon') + '</button>';
      else if (!o) dugme = '<button class="rm-btn kucuk kagit" disabled>' + sayi(x.coin) + '</button>';
      else if (o.coin.bakiye >= x.coin) dugme = '<button class="rm-btn kucuk" data-eylem="odul-al" data-id="' + x.id + '">' + T('Al', 'Get') + '</button>';
      else dugme = '<button class="rm-btn kucuk kagit" disabled>' + sayi(x.coin - o.coin.bakiye) + T(' eksik', ' short') + '</button>';
      return '<div class="rm-odul' + (x.aktif ? '' : ' pasif') + '"><div class="rm-odul-fiyat">' + sayi(x.coin) + '</div>' +
        '<div><h3>' + kacis(odulBilgi(x).baslik) + '</h3><p>' + kacis(odulBilgi(x).aciklama) + '</p></div>' + dugme + '</div>';
    }).join('');
  }
  function odulSor(id) {
    var x = A.oduller.filter(function (o) { return o.id === id; })[0];
    if (!x) return;
    pencere('<h2 class="rm-baslik">' + kacis(odulBilgi(x).baslik) + '</h2>' +
      '<p><b>' + sayi(x.coin) + ' Coin</b> ' + (TR ? 'harcanacak. Hesabına özel, tek kullanımlık bir indirim kodu oluşturulacak (' + A.odulKodGecerlilikGun + ' gün geçerli).' : 'will be spent. A single-use discount code made for your account will be created (valid for ' + A.odulKodGecerlilikGun + ' days).') + '</p>' +
      '<div class="rm-dugmeler"><button class="rm-btn genis" data-eylem="odul-onay" data-id="' + x.id + '">' + T('Onayla', 'Confirm') + '</button>' +
      '<button class="rm-btn genis kagit" data-eylem="kapat">' + T('Vazgeç', 'Cancel') + '</button></div>', true);
  }
  async function odulAl(id, btn) {
    btn.disabled = true;
    btn.textContent = T('Kod oluşturuluyor…', 'Creating code…');
    try {
      var r = await istek({ islem: 'odul', odul: id });
      if (r.durum) durum = r.durum;
      if (!r.ok) {
        odullerEkrani();
        pencere('<h2 class="rm-baslik">' + T('Olmadı', 'Not this time') + '</h2><p>' + kacis(hataMetni(r.hata)) + '</p><div class="rm-dugmeler"><button class="rm-btn genis" data-eylem="kapat">' + T('Tamam', 'OK') + '</button></div>', true);
        return;
      }
      odullerEkrani();
      pencere('<h2 class="rm-baslik">' + T('Kodun hazır', 'Your code is ready') + '</h2>' +
        '<div class="rm-kod"><button data-eylem="kopyala" data-kod="' + kacis(r.odul.kod) + '">' + kacis(r.odul.kod) + '</button><small>' + T('Kopyalamak için dokun, sepette kullan.', 'Tap to copy, use it in your cart.') + '</small></div>' +
        '<div class="rm-dugmeler"><button class="rm-btn genis" data-eylem="kapat">' + T('Tamam', 'OK') + '</button></div>', true);
    } catch (e) {
      pencere('<h2 class="rm-baslik">' + T('Bağlantı koptu', 'Connection lost') + '</h2><p>' + T('Kodun oluştuysa Ödüller sayfasında görünür. Görmüyorsan biraz sonra tekrar dene.', 'If your code was created, it will show on the Rewards page. If you don\'t see it, try again in a moment.') + '</p>' +
        '<div class="rm-dugmeler"><button class="rm-btn genis" data-eylem="kapat">' + T('Tamam', 'OK') + '</button></div>', true);
    }
  }
  function kopyala(kod, el) {
    function oldu() { bildirim(T('Kod kopyalandı: ', 'Code copied: ') + kod); }
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(kod).then(oldu, function () { secMetin(el); bildirim(T('Kodu seçtim, kopyalayabilirsin', 'Code selected, you can copy it')); });
    } else { secMetin(el); bildirim(T('Kodu seçtim, kopyalayabilirsin', 'Code selected, you can copy it')); }
  }
  function secMetin(el) { try { var r = document.createRange(); r.selectNodeContents(el); var s = getSelection(); s.removeAllRanges(); s.addRange(r); } catch (e) { /* secilemedi */ } }

  // ---------- ayarlar ----------

  function ayarlarEkrani() {
    function secici(ad, secenekler, deger) {
      return '<span class="rm-secici">' + secenekler.map(function (s) {
        return '<button data-eylem="tercih" data-ad="' + ad + '" data-deger="' + s[0] + '" class="' + (String(deger) === s[0] ? 'secili' : '') + '">' + s[1] + '</button>';
      }).join('') + '</span>';
    }
    ekran('rm-ayarlar', ustBar(T('Ayarlar', 'Settings')) + '<div class="rm-liste">' +
      '<div class="rm-ayar">' + T('Animasyon hızı', 'Animation speed') + ' ' + secici('hiz', [['normal', 'Normal'], ['hizli', T('Hızlı', 'Fast')]], tercih.hiz) + '</div>' +
      '<div class="rm-ayar">' + T('Titreşim', 'Vibration') + ' ' + secici('titresim', [['true', T('Açık', 'On')], ['false', T('Kapalı', 'Off')]], tercih.titresim) + '</div>' +
      '<h3 class="rm-bolum-baslik">' + T('Nasıl oynanır', 'How to play') + '</h3><div class="rm-metin">' +
        T('<p>Yan yana iki meyvenin yerini değiştir. Aynı meyveden 3 ya da daha fazlasını yan yana ya da alt alta dizersen patlarlar.</p>', '<p>Swap two neighboring fruits. If you line up 3 or more of the same fruit side by side or one above the other, they pop.</p>') +
        T('<p><b>4\'lü</b> sıra roket çıkarır: bütün satırı ya da sütunu temizler. <b>L ya da T</b> şekli bomba çıkarır: etrafını temizler. <b>5\'li</b> düz sıra güneş çıkarır: bir meyveyle yer değiştirince o meyvenin hepsi gider. İki power-up\'ı yan yana getirip birleştirirsen daha büyük patlar.</p>', '<p>A row of <b>4</b> creates a rocket: it clears a whole row or column. An <b>L or T</b> shape creates a bomb: it clears the area around it. A straight row of <b>5</b> creates a sun: swap it with a fruit and every fruit of that kind disappears. If you combine two power-ups side by side, the blast is bigger.</p>') +
        T('<p>Power-up\'lar kendiliğinden patlamaz: onu bir meyveyle kaydır ya da üstüne iki kez dokun. Başka bir patlama çarparsa o da patlar.</p>', '<p>Power-ups do not explode on their own: slide one with a fruit or double-tap it. If another explosion hits it, it explodes too.</p>') +
        T('<p>Buzu kırmak için üstünde eşleşme yap. İnce buz bir, kalın buz iki vuruşta kırılır; zincirleme patlamalar da vuruş sayılır. Kutunun yanında eşleşme yaparsan kutu açılır. Sarmaşıklı meyve yerinden oynamaz; onu bir eşleşmeye katınca sarmaşık kopar.</p>', '<p>To break ice, make a match on top of it. Thin ice breaks in one hit, thick ice in two; chain explosions count as hits too. If you make a match next to a crate, the crate opens. A vine-wrapped fruit does not move; include it in a match and the vine breaks.</p>') +
      '</div><h3 class="rm-bolum-baslik">' + T('Yıldız ve Coin', 'Stars and Coin') + '</h3><div class="rm-metin">' +
        T('<p><b>Yıldız</b> kaç hamle artırdığına göre verilir: level\'ı geçmek 1 yıldız, daha az hamlede bitirirsen 2 ya da 3 yıldız. Her level\'ın başında kaç hamle kala kaç yıldız alacağın yazar; oyun sırasında da üstteki yıldızlar hangisinin hâlâ alınabilir olduğunu gösterir.</p>', '<p><b>Stars</b> depend on how many moves you save: passing a level gives 1 star, and finishing in fewer moves gives 2 or 3 stars. At the start of each level it shows how many moves left earn how many stars; during play, the stars at the top show which ones can still be earned.</p>') +
        (TR ? '<p><b>Coin</b> her level\'ın ilk geçişinde gelir: geçiş ' + A.gecisCoini(1) + '–' + A.gecisCoini(A.leveller.length) + ' Coin (ileri level\'lar daha çok verir) ve her yıldız +' + A.ekonomi.yildizBasina + '. Bir level\'ı tekrar oynayıp daha çok yıldız alırsan yeni yıldızların Coin\'ini alırsın; aynı sonucu tekrarlamak Coin getirmez. Bütün level\'ları 3 yıldızla bitiren ' + sayi(tumCoin()) + ' Coin toplar. Biriken Coin\'i Ödüller\'de indirim koduna çevirebilirsin.</p></div>' : '<p><b>Coin</b> comes the first time you pass each level: ' + A.gecisCoini(1) + '–' + A.gecisCoini(A.leveller.length) + ' Coin for passing (later levels give more) and +' + A.ekonomi.yildizBasina + ' for each star. If you replay a level and earn more stars, you get the Coin for the new stars; repeating the same result gives no Coin. Finishing all levels with 3 stars collects ' + sayi(tumCoin()) + ' Coin. You can turn your saved Coin into a discount code in Rewards.</p></div>') +
      '<h3 class="rm-bolum-baslik">' + T('Hesap', 'Account') + '</h3><div class="rm-metin">' +
        T('<p>Ruma hesabınla oynuyorsun. İlerlemen ve Coin\'in hesabına kaydediliyor; başka cihazdan girince kaldığın yerden devam edersin.</p>', '<p>You play with your Ruma account. Your progress and Coin are saved to your account; when you log in on another device, you continue where you left off.</p>') +
      '</div><p style="margin-top:14px"><a class="rm-btn kucuk kagit" href="' + kacis(cfg.magaza) + '">' + T('rumajew.com\'a dön', 'Back to rumajew.com') + '</a></p></div>');
  }

  // ---------- eylemler ----------

  sahne.addEventListener('click', function (e) {
    var el = e.target.closest('[data-eylem]');
    if (!el || el.disabled) return;
    var ey = el.getAttribute('data-eylem'), n = parseInt(el.getAttribute('data-n'), 10);
    switch (ey) {
      case 'ana': pencereKapat(); oyun = null; anaEkran(); break;
      case 'harita': pencereKapat(); oyun = null; haritaEkrani(); break;
      case 'oduller': odullerEkrani(); break;
      case 'ayarlar': ayarlarEkrani(); break;
      case 'level': pencereKapat(); levelGiris(n); break;
      case 'oyna': levelBaslat(n); break;
      case 'kapat': pencereKapat(); break;
      case 'cik': cikisSor(); break;
      case 'cik-onay': pencereKapat(); oyun = null; anaEkran(); break;
      case 'giris': window.location.href = cfg.giris; break;
      case 'odul-al': odulSor(el.getAttribute('data-id')); break;
      case 'odul-onay': odulAl(el.getAttribute('data-id'), el); break;
      case 'kopyala': kopyala(el.getAttribute('data-kod'), el); break;
      case 'tercih':
        var ad = el.getAttribute('data-ad'), d = el.getAttribute('data-deger');
        tercih[ad] = ad === 'titresim' ? d === 'true' : d;
        tercihYaz(); ayarlarEkrani(); break;
      case 'yeniden':
        sahne.innerHTML = '<div class="rm-yukleniyor">' + C.ikon('rm-o-gunes') + '</div>';
        durumYukle().then(baslangicEkrani); break;
    }
  });

  // Ekran boyutu degisince tahtayi yeniden olcekle
  var boyutSayac = null;
  window.addEventListener('resize', function () {
    clearTimeout(boyutSayac);
    boyutSayac = setTimeout(function () {
      if (!oyun || !oyun.katman) return;
      var H = hucreBoyutu();
      if (H === oyun.H) return;
      oyun.H = H;
      kok.style.setProperty('--hucre', H + 'px');
      Object.keys(oyun.parcalar).forEach(function (id) { var el = oyun.parcalar[id]; konumla(el, el._r, el._c, 0); });
      Object.keys(oyun.ortuler).forEach(function (k) {
        var p = k.slice(1).split('_');
        oyun.ortuler[k].style.transform = 'translate(' + (p[1] * H) + 'px,' + (p[0] * H) + 'px)';
      });
    }, 150);
  });

  // Yerel test sayfasi (sahte sunucu) icin oyun durumuna erisim; canli sitede tanimlanmaz
  if (window.RumaMatchSahteSunucu) window.RumaMatchTest = { oyun: function () { return oyun; }, dene: dene };

  // ---------- baslat ----------

  sahne.innerHTML = '<div class="rm-yukleniyor">' + C.ikon('rm-o-gunes') + '</div>';
  durumYukle().then(baslangicEkrani);
})();
